import { Loader2 } from 'lucide-react';

import { cn } from '@nesso/ui/lib/utils';

interface Props {
    title?: string;
    description?: string;
    size?: 'default' | 'large';
}

export function SessionNoteLoader({ title, description, size = 'default' }: Props) {
    return (
        <div className="flex flex-col items-center justify-center h-full py-10">
            <div className="text-center space-y-1 flex flex-col items-center">
                <span className="flex items-center gap-2">
                    <Loader2
                        className={cn(
                            'animate-spin',
                            size === 'large' ? 'h-8 w-8' : 'h-4 w-4 text-secondary',
                        )}
                    />
                    {title && <p className="text-lg font-medium text-foreground">{title}</p>}
                </span>
                {description && <p className="text-sm text-muted-foreground">{description}</p>}
            </div>
        </div>
    );
}
